import React from 'react';
import { Curious } from '@curi/react-universal';
export * from '@curi/react-universal';
import shallowEqual from 'shallowequal';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function canNavigate(event) {
    return (!event.defaultPrevented &&
        event.button === 0 &&
        !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey));
}
var hasWarnedTo = false;
var hasWarnedForward = false;
var BaseLink = /** #__PURE__ */ (function (_super) {
    __extends(BaseLink, _super);
    function BaseLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            navigating: false
        };
        _this.clickHandler = function (event) {
            var _a = _this.props, onClick = _a.onClick, router = _a.router, target = _a.target;
            if (onClick) {
                onClick(event);
            }
            if (canNavigate(event) && !target) {
                event.preventDefault();
                var _b = _this.props, to = _b.to, name_1 = _b.name, params = _b.params, query = _b.query, state = _b.state, hash = _b.hash;
                var routeName = name_1 || to;
                var cancelled = void 0, finished = void 0;
                // only trigger re-renders when children uses state
                if (typeof _this.props.children === "function") {
                    cancelled = finished = function () {
                        if (!_this.removed) {
                            _this.setState({ navigating: false });
                        }
                    };
                    if (!_this.removed) {
                        _this.setState({ navigating: true });
                    }
                }
                router.navigate({
                    name: routeName,
                    params: params,
                    query: query,
                    state: state,
                    hash: hash,
                    cancelled: cancelled,
                    finished: finished
                });
            }
        };
        return _this;
    }
    BaseLink.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var nextParams = nextProps.params, nextForward = nextProps.forward, nextRest = __rest(nextProps, ["params", "forward"]);
        var _a = this.props, currentParams = _a.params, currentForward = _a.forward, currentRest = __rest(_a, ["params", "forward"]);
        return (!shallowEqual(nextState, this.state) ||
            !shallowEqual(nextParams, currentParams) ||
            !shallowEqual(nextRest, currentRest) ||
            !shallowEqual(nextForward, currentForward));
    };
    BaseLink.prototype.render = function () {
        var _a = this.props, to = _a.to, name = _a.name, params = _a.params, hash = _a.hash, query = _a.query, state = _a.state, onClick = _a.onClick, anchor = _a.anchor, router = _a.router, forwardedRef = _a.forwardedRef, children = _a.children, forward = _a.forward, rest = __rest(_a, ["to", "name", "params", "hash", "query", "state", "onClick", "anchor", "router", "forwardedRef", "children", "forward"]);
        if (process.env.NODE_ENV !== "production") {
            if (!hasWarnedTo && to !== undefined) {
                hasWarnedTo = true;
                console.warn("Deprecation warning:\nThe \"to\" prop should be replaced with the \"name\" prop. The \"to\" prop will be removed in @curi/react-dom v2.\n\n<Link name=\"Route Name\">...</Link>");
            }
            if (!hasWarnedForward && Object.keys(rest).length > 0) {
                hasWarnedForward = true;
                console.warn("Deprecation warning:\nPassing additional props to a <Link> will no longer be forwarded to the rendered component in v2.\n\nInstead, please use the \"forward\" prop to pass an object of props to be attached to the component.\n\n<Link to=\"Route Name\" forward={{ className: \"test\" }}>");
            }
        }
        var routeName = name || to;
        var Anchor = anchor ? anchor : "a";
        var href = router.history.toHref({
            hash: hash,
            query: query,
            state: state,
            pathname: routeName ? router.route.pathname(routeName, params) : ""
        });
        var additionalProps = __assign({}, rest, forward);
        return (React.createElement(Anchor, __assign({}, additionalProps, { onClick: this.clickHandler, href: href, ref: forwardedRef }), typeof children === "function"
            ? children(this.state.navigating)
            : children));
    };
    BaseLink.prototype.componentWillUnmount = function () {
        this.removed = true;
    };
    return BaseLink;
}(React.Component));
var Link = /** #__PURE__ */ React.forwardRef(function (props, ref) { return (React.createElement(Curious, null, function (_a) {
    var router = _a.router;
    return (React.createElement(BaseLink, __assign({}, props, { router: router, forwardedRef: ref })));
})); });

var FocusWithResponse = /** #__PURE__ */ (function (_super) {
    __extends(FocusWithResponse, _super);
    function FocusWithResponse(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (element) {
            _this.eleToFocus = element;
        };
        _this.eleToFocus = null;
        return _this;
    }
    FocusWithResponse.prototype.render = function () {
        var children = this.props.children;
        return children(this.setRef);
    };
    FocusWithResponse.prototype.componentDidMount = function () {
        this.focus();
    };
    FocusWithResponse.prototype.componentDidUpdate = function (prevProps) {
        // only re-focus when the response changes
        if (prevProps.response !== this.props.response) {
            this.focus();
        }
    };
    FocusWithResponse.prototype.focus = function () {
        var _this = this;
        // https://developers.google.com/web/fundamentals/accessibility/focus/using-tabindex#managing_focus_at_the_page_level
        if (this.eleToFocus !== null) {
            if (process.env.NODE_ENV !== "production") {
                if (!this.eleToFocus.hasAttribute("tabIndex") &&
                    this.eleToFocus.tabIndex === -1) {
                    console.warn('The component that is passed the ref must have a "tabIndex" prop or be focusable by default in order to be focused. ' +
                        "Otherwise, the document's <body> will be focused instead.");
                }
            }
            if (this.props.preserve &&
                this.eleToFocus.contains(document.activeElement)) {
                return;
            }
            setTimeout(function () {
                // @ts-ignore
                _this.eleToFocus.focus({ preventScroll: _this.props.preventScroll });
            });
        }
        else {
            if (process.env.NODE_ENV !== "production") {
                console.warn("There is no element to focus. Did you forget to add the ref to an element?");
            }
        }
    };
    FocusWithResponse.defaultProps = {
        preventScroll: false
    };
    return FocusWithResponse;
}(React.Component));
function Focus(props) {
    return (React.createElement(Curious, null, function (_a) {
        var response = _a.response;
        return (React.createElement(FocusWithResponse, __assign({ response: response }, props), props.children));
    }));
}

export { Link, Focus };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@curi/react-dom/dist/curi-react-dom.es.js
// module id = 39
// module chunks = 0